import React from 'react';

function formatDateShort(val) {
  if (!val) return '';
  try {
    let dateStr = val;
    if (dateStr.includes('T')) dateStr = dateStr.split('T')[0];
    const parts = dateStr.split('-');
    if (parts.length === 3) {
      const yy = parts[0].slice(-2);
      return `${parts[1]}/${parts[2]}/${yy}`;
    }
  } catch (e) {}
  return val;
}

function isWithin30Days(train) {
  // Use etdTerminal (departure from terminal) as the reference date
  const dateStr = train.etdTerminal || train.etaTerminal || '';
  if (!dateStr) return true; // keep if no date
  try {
    let d = dateStr;
    if (d.includes('T')) d = d.split('T')[0];
    const trainDate = new Date(d + 'T00:00:00');
    const now = new Date();
    const cutoff = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);
    const past = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
    return trainDate >= past && trainDate <= cutoff;
  } catch (e) {
    return true;
  }
}

export default function TrainSchedule({ schedule, accentColor }) {
  const terminals = ['AMA', 'FET'];
  const cols = ['Train #', 'ETD Origin', 'ETA Terminal', 'ETD Terminal', 'ETA Port'];

  return (
    <div className="space-y-6">
      {terminals.map((terminal) => {
        const allTrains = schedule[terminal] || [];
        const trains = allTrains.filter(isWithin30Days);
        return (
          <div key={terminal}>
            <h3 className="text-sm font-bold mb-2" style={{ color: accentColor }}>
              {terminal === 'AMA' ? 'Amarillo (AMA)' : 'Fremont (FET)'}
            </h3>
            {trains.length === 0 ? (
              <p className="text-gray-500 text-xs">No scheduled trains.</p>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full text-xs">
                  <thead>
                    <tr className="bg-gray-50 border-b">
                      {cols.map((col) => (
                        <th key={col} className="px-2 py-1.5 text-left text-xs font-medium text-gray-500 uppercase">
                          {col}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {trains.map((train, idx) => (
                      <tr
                        key={idx}
                        className={train.hasCustomerContainers ? 'bg-green-50' : 'hover:bg-gray-50'}
                      >
                        <td className="px-2 py-1 font-medium">
                          {train.trainNumber}
                          {train.hasCustomerContainers && (
                            <span className="ml-1 inline-block w-2 h-2 bg-green-500 rounded-full" title="Has customer containers" />
                          )}
                        </td>
                        <td className="px-2 py-1">{formatDateShort(train.etdOrigin)}</td>
                        <td className="px-2 py-1">{formatDateShort(train.etaTerminal)}</td>
                        <td className="px-2 py-1">{formatDateShort(train.etdTerminal)}</td>
                        <td className="px-2 py-1">{formatDateShort(train.etaPort)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
